module.exports = __webpack_public_path__ + "img/icon-menu-left.49983f89.svg";